import React from "react";
import { Modal, ModalBuilder } from "@redriver/cinnamon";
import { syncSheetStatesWithSettings } from "features/Sheets/ManageSheet/actions";
import WarningBanner from "features/../../../shared/components/banners/WarningBanner";
import { useTranslation } from "react-i18next";

const LargeFormatConflictModal = ({ sheetId }) => {
  const { t } = useTranslation("sheetTranslation", {
    keyPrefix: "ConflictModal",
  });
  return (
    <ModalBuilder
      loadAction={syncSheetStatesWithSettings}
      loadParams={sheetId}
      visible={true}
      onSubmit={() => window.location.reload()}
      renderModal={(modalProps) => (
        <Modal.Information header="" {...modalProps}>
          <WarningBanner warningText="Warning" />
          <div style={{ padding: "10px" }}>
            <p>{t("LargeFormatGroupConflictMessage")}</p>
          </div>
        </Modal.Information>
      )}
    />
  );
};
export default LargeFormatConflictModal;
